import { ViewCustomer } from '@xeetr/types/models'

import ApiService from './common/API.service'

export interface PaginatedCustomerResponse {
  data: ViewCustomer[]
  total: number
  page: number
  limit: number
}

export class CustomerService extends ApiService {
  getCustomers = async (
    page: number = 1,
    limit: number = 10,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc'
  ): Promise<PaginatedCustomerResponse> => {
    const { data } = await this.get<PaginatedCustomerResponse>(this.buildCommonUrl('customer'), {
      params: { page, limit, sortBy, sortOrder },
    })
    return data
  }

  filterCustomer = async (
    searchTerm: string,
    page: number = 1,
    limit: number = 50,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc'
  ): Promise<PaginatedCustomerResponse> => {
    const filters = searchTerm.trim().split(' ')
    const { data } = await this.get<PaginatedCustomerResponse>(this.buildCommonUrl('customer'), {
      params: { filter: filters, page, limit, sortBy, sortOrder },
    })
    return data
  }

  createCustomer = async (customer: ViewCustomer): Promise<ViewCustomer> => {
    const { data } = await this.put<ViewCustomer, ViewCustomer>(
      this.buildCommonUrl('customer'),
      customer
    )
    return data
  }

  updateCustomer = async (customer: ViewCustomer): Promise<ViewCustomer> => {
    const { data } = await this.put<ViewCustomer, ViewCustomer>(
      this.buildCommonUrl('customer'),
      customer
    )
    return data
  }

  deleteCustomer = async (customerId: string): Promise<void> => {
    await this.delete<void>(this.buildCommonUrl(`customer/${customerId}`))
  }

  getCustomerBookingCounts = async (): Promise<Record<string, number>> => {
    const { data } = await this.get<Record<string, number>>(
      this.buildCommonUrl('customer/booking-counts')
    )
    return data
  }

  getCustomer = async (customerId: string): Promise<ViewCustomer> => {
    const { data } = await this.get<ViewCustomer>(this.buildCommonUrl(`customer/${customerId}`))
    return data
  }
}
